import * as React from 'react';
import './styles.scss';
import { FollowingPublisher } from 'client/respondent/core/types';
import {
  Autocomplete,
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
} from '@mui/material';
import { useRedirect } from 'client/shared/hooks';
import { ClientUrlUtils } from 'client/shared/core/helpers';
import _ from 'lodash';
import { usePublisherSubscriptionData } from 'client/respondent/hooks/use-respondent-subscription-info';

const MAX_SEARCH_RESULT = 20;

export const SearchPublisherNav: React.FC<{
  readonly respondentId: string | null;
}> = (props) => {
  const [curText, setCurText] = React.useState('');

  const sidebarData = usePublisherSubscriptionData(props.respondentId ?? undefined);

  const redirect = useRedirect();

  const searchedPubs = searchPub(
    [...sidebarData.subscribedPubs, ...sidebarData.subscribablePubs],
    curText
  );

  return (
    <Autocomplete
      getOptionLabel={(option) => option.name}
      inputValue={curText}
      onChange={(_p, value) => {
        if (value) {
          redirect(ClientUrlUtils.respondent.pubProfile.path({ slug: value.slug }), {
            push: true,
          });
          setCurText('');
        }
      }}
      onInputChange={(_p, value) => setCurText(value)}
      options={searchedPubs}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search Publishers"
          size="small"
          variant="outlined"
        />
      )}
      renderOption={(p, option) => (
        <ListItem key={option.id} {..._.omit(p, 'key')}>
          {option.seal && (
            <ListItemAvatar>
              <Avatar src={option.seal} sx={{ width: 32, height: 32 }} />
            </ListItemAvatar>
          )}
          <ListItemText
            primary={option.name}
            secondary={option.location ? option.location : ''}
          />
        </ListItem>
      )}
      style={{ width: 300 }}
    />
  );
};
SearchPublisherNav.displayName = 'SearchPublisherNav';

const searchPub = (pubs: readonly FollowingPublisher[], searchKeyword: string) => {
  // for performance reasons, we show only first 20 results
  const totalFilteredPubs = pubs.filter((pub) => {
    const pubName = pub.name;
    return pubName.toLowerCase().includes(searchKeyword.toLowerCase());
  });
  return _.take(totalFilteredPubs, MAX_SEARCH_RESULT);
};
